<div class="certificate-contract-details flex flex-col gap-6"
     [formGroup]="form()"
>
  <div *albertIfCategory="'furtherInsured'; config: visibility">
    <albert-input-wrapper actionsLayout="row"
                          data-test="wrapper-certificate-contract-details-further-insured"
                          groupName="furtherInsured"
                          tooltipLabel="Further Insured for this Certificate"
                          [disabled]="!canEdit()"
    >
      <albert-multiselect controlName="furtherInsured"
                          dataKey="company"
                          dataTest="certificate-contract-details-further-insured"
                          inputId="furtherInsured"
                          label="Further Insured for this Certificate"
                          optionLabel="company"
                          [disabled]="!canEdit()"
                          [filter]="true"
                          [maxSelectedLabels]="3"
                          [options]="options()"
                          (filterEvent)="onFilter($event)"
                          (modelChange)="onSelectionChange($event)"
      />
      <span class="w-fit"
            leadingActions
            tooltipPosition="left"
            [pTooltip]="selectedFurtherInsured().length > 0 ? 'Show Limits of Further Insured' : 'No Further Insured Selected'"
      >
        <button class="clear-input-btn"
                data-test="certificate-contract-details-further-insured-limits"
                iconOnly
                outlined="true"
                pButton
                severity="secondary"
                type="button"
                [disabled]="selectedFurtherInsured().length === 0"
                (click)="onShowFurtherInsuredLimits()"
        >
          <i class="pi pi-table"></i>
        </button>
      </span>
    </albert-input-wrapper>
  </div>

  <div class="flex flex-col gap-6">
    <albert-input-wrapper *albertIfCategory="'contractParties'; config: visibility"
                          data-test="wrapper-certificate-contract-details-contract-parties"
                          groupName="contractParties"
                          tooltipLabel="Contract Parties"
                          [disabled]="!canEdit()"
    >
      <albert-textarea data-test="certificate-contract-details-contract-parties"
                       groupName="contractParties"
                       inputId="contractParties"
                       [disabled]="!canEdit()"
                       [label]="'Contract Parties'"
                       [rows]="16"
      />
      <button actions
              class="clear-input-btn"
              data-test="certificate-contract-details-contract-parties-additional-action"
              iconOnly
              outlined="true"
              pButton
              severity="secondary"
              tooltipPosition="left"
              type="button"
              [pTooltip]="`EUAT List`"
              (click)="onOpenEuatCheck()"
      >
        <i class="pi pi-shield"></i>
      </button>
    </albert-input-wrapper>
    <albert-input-wrapper *albertIfCategory="'contracts'; config: visibility"
                          data-test="wrapper-certificate-contract-details-contracts"
                          groupName="contracts"
                          tooltipLabel="Contracts"
                          [disabled]="!canEdit()"
    >
      <albert-textarea data-test="certificate-contract-details-contracts"
                       groupName="contracts"
                       inputId="contracts"
                       [disabled]="!canEdit()"
                       [label]="'Contracts'"
                       [rows]="12"
      />
    </albert-input-wrapper>
  </div>
  @if (categoryService.activeCertificateCategory() === CertificateCategory.AUTHORITIES
  || categoryService.activeCertificateCategory() === CertificateCategory.LEASE) {
    <div class="comparison-grid expanded-mode"
         data-test="certificate-contract-details-comparison-grid"
    >
      <div *albertIfCategory="'avn67B'; config: visibility">
        <albert-checkbox controlName="avn67B"
                         data-test="certificate-contract-details-avn67b"
                         groupName="avn67B"
                         inputId="avn67B"
                         label="AVN67B"
                         [disabled]="!canEdit()"
        />
      </div>
      <div *albertIfCategory="'avn67C'; config: visibility"
           class="override-cell"
      >
        <albert-checkbox controlName="avn67C"
                         data-test="certificate-contract-details-avn67c"
                         groupName="avn67C"
                         inputId="avn67C"
                         label="AVN67C"
                         [disabled]="!canEdit()"
        />
      </div>
      <div *albertIfCategory="'designatedContractParty'; config: visibility"></div>
      <div *albertIfCategory="'designatedContractParty'; config: visibility"
           class="override-cell"
      >
        <albert-input-wrapper data-test="wrapper-certificate-contract-details-designated-contract-party"
                              groupName="designatedContractParty"
                              tooltipLabel="Designated Contract Party"
                              [disabled]="!canEdit() || (!form().controls.avn67C.value)"
        >
          <albert-input controlName="designatedContractParty"
                        data-test="certificate-contract-details-designated-contract-party"
                        groupName="designatedContractParty"
                        inputId="designatedContractParty"
                        label="Designated Contract Party"
                        [disabled]="!canEdit() || (!form().controls.avn67C.value)"
                        [required]="true"
          />
        </albert-input-wrapper>
      </div>
    </div>
  }
</div>

<ng-template #furtherInsuredLimits>
  <albert-further-insured-limits [editable]="canEdit()"
                                 [insured]="selectedFurtherInsured()"
                                 [periodUuid]="periodUuid()"
                                 (policyChange)="onFurtherInsuredPolicyChange($event)"
  />
</ng-template>

<ng-template #euatCheck>
  <div class="euat-check"
       data-test="certificate-contract-details-euat-check"
  >
    <p-iftalabel class="euat-check-text">
      <textarea class="w-full h-full"
                data-test="certificate-contract-details-euat-check-contract-parties"
                id="euatCheckContractParties"
                pTextarea
                [disabled]="true"
                [value]="form().controls.contractParties.value ?? ''"
      ></textarea>
      <label for="euatCheckContractParties">Contract Parties</label>
    </p-iftalabel>

    <div class="euat-check-companies">
      <p-table data-test="certificate-contract-details-euat-check-table"
               scrollHeight="400px"
               scrollable="true"
               [loading]="extractingCompanies()"
               [value]="contractPartyRows()"
      >
        <ng-template #header>
          <tr>
            <th id="euat-check-company">Company</th>
            <th id="euat-check-country">Country</th>
            <th id="euat-check-result">EUAT Check</th>
            <th id="euat-check-created-on">Created on</th>
            <th id="euat-check-created-by">Created by</th>
            <th id="euat-check-edited-on">Edited on</th>
            <th id="euat-check-edited-by">Edited by</th>
            <th id="euat-check-actions"></th>
          </tr>
        </ng-template>
        <ng-template #body
                     let-row
        >
          <tr data-test="certificate-contract-details-euat-check-row">
            <td>
              @if (canEdit()) {
                <input aria-label="Company"
                       class="w-full"
                       data-test="certificate-contract-details-euat-check-company"
                       id="certificate-contract-details-euat-check-company"
                       pInputText
                       type="text"
                       [ngModelOptions]="{ standalone: true }"
                       [(ngModel)]="row.company"
                />
              } @else {
                {{ row.company }}
              }
            </td>
            <td>
              @if (canEdit()) {
                <p-select appendTo="body"
                          class="w-full"
                          data-test="certificate-contract-details-euat-check-country"
                          optionLabel="label"
                          optionValue="value"
                          placeholder="Select"
                          [filter]="true"
                          [ngModelOptions]="{ standalone: true }"
                          [options]="countryOptions()"
                          [showClear]="true"
                          [(ngModel)]="row.country"
                />
              } @else {
                {{ countryLabel(row.country) }}
              }
            </td>
            <td data-test="certificate-contract-details-euat-check-result">{{ row.euatCheckResult }}</td>
            <td class="euat-check-date">{{ formatDisplayDate(row.createdOn) }}</td>
            <td>{{ row.createdBy }}</td>
            <td class="euat-check-date">{{ formatDisplayDate(row.editedOn) }}</td>
            <td>{{ row.editedBy }}</td>
            <td>
              @if (canEdit()) {
                <button data-test="certificate-contract-details-euat-check-remove"
                        iconOnly
                        pButton
                        severity="secondary"
                        type="button"
                        [text]="true"
                        (click)="onRemoveContractPartyRow(row)"
                >
                  <i class="pi pi-times"></i>
                </button>
              }
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td colspan="8">No companies recognised.</td>
          </tr>
        </ng-template>
      </p-table>

      @if (canEdit()) {
        <button data-test="certificate-contract-details-euat-check-add"
                pButton
                severity="secondary"
                size="small"
                type="button"
                (click)="onAddContractPartyRow()"
        >
          <i class="pi pi-plus"></i>
          Add Contract Party
        </button>
      }
    </div>
  </div>
</ng-template>
